/**
 * Utility service for managing Bootstrap Offcanvas state across the application
 */
export class OffcanvasUtilsService {
  
  /**
   * Checks if any offcanvas is currently visible in the DOM
   * @returns boolean - true if any offcanvas is visible, false otherwise
   */
  static isOffcanvasVisible(): boolean {
    // Check for existing backdrop elements
    const backdrops = document.querySelectorAll('.offcanvas-backdrop');
    if (backdrops.length > 0) {
      return true;
    }
    
    // Check for offcanvas elements with 'show' or 'showing' classes
    const activeOffcanvas = document.querySelectorAll('.offcanvas.show, .offcanvas.showing');
    if (activeOffcanvas.length > 0) {
      return true;
    }

    // Check for offcanvas elements that are not hidden (Bootstrap removes display:none when showing)
    const visibleOffcanvas = document.querySelectorAll('.offcanvas');
    for (let i = 0; i < visibleOffcanvas.length; i++) {
      const element = visibleOffcanvas[i] as HTMLElement;
      const computedStyle = window.getComputedStyle(element);
      if (computedStyle.display !== 'none' && computedStyle.visibility !== 'hidden') {
        return true;
      }
    }
    
    return false;
  }

  /**
   * Forces cleanup of any remaining offcanvas backdrop elements
   * Useful for ensuring clean state before showing new offcanvas
   */
  static forceCleanupBackdrops(): void {
    const backdrops = document.querySelectorAll('.offcanvas-backdrop');
    backdrops.forEach(backdrop => {
      backdrop.remove();
    });

    // Reset body styles that Bootstrap might have set
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
    document.body.classList.remove('offcanvas-open');
    document.body.classList.remove('modal-open');
  }
}